function MensajeVacio({texto, mostrar}) {
    return (
    <>
    {mostrar ? (
    <div class="box-info" style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '16px 24px 12px 16px',
        marginTop: '0px',
        border: 'none',
        position: 'absolute',
        top: '50px',
        left: '-2px',
        width: '101%',
        maxHeight: '250px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #9c3838',
        borderRadius: '4px',
        boxShadow: 'none',
        zIndex: 110,
        }}
    >
    <div style={{height: '260px'}}>
        <p class="p-box-i">{texto}</p>
    </div>
    </div>
    ) : '' }
    </>);
}

export default MensajeVacio